<script setup lang="ts">
import type { HTMLAttributes } from 'vue'
import { cn } from '@/ui/lib/utils'

const props = defineProps<{
  class?: HTMLAttributes['class']
}>()
</script>

<template>
  <thead data-slot="table-header" :class="cn('bg-muted [&_tr]:border-b [&_tr]:hover:bg-muted', props.class)">
    <slot />
  </thead>
</template>
